export enum EProductType {
  FREE = "Free",
  PREMIUM = "Premium",
  HOUSEHOLD = "Household",
}
